import { useEffect } from 'react';

import { getAnalyticsData } from '@/helpers/cookieHelpers';

export const useRouteChangedGTMEvent = () => {
  useEffect(() => {
    async function updateAnalyticsData() {
      const analyticsData = await getAnalyticsData();

      (window as any).dataLayer?.push({
        event: 'route_changed',
        ...analyticsData,
      });
    }

    updateAnalyticsData();
  }, []);
};
